<template>
  <div class="full-width bg-white">
    <div class="container">
      <div
        class="flex justify-center align-center full-width"
        v-if="partnersList && partnersList.length"
      >
        <div class="partner-info full-width">
          <div class="flex justify-center align-center">
            <h1>{{ partnersList ? partnersList[0].name : '' }}</h1>
          </div>

          <img
            :src="partnersList[0].logo"
            :style="UI.isMobile ? 'width: 100%;' : 'width: 100%;'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPartnersList } from '@/servers/homepage.js';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      partnersList: [],
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  created() {
    let that = this;
    getPartnersList({ page_size: 8 }, function(res) {
      that.partnersList = res.items;
    });
  },
};
</script>

<style lang="scss">
// .partner-container {
//   @media screen and (min-width: 1500px) {
//     .partner-info {
//       width: 1200px;
//     }
//   }

//   @media screen and (max-width: 1500px) {
//     .partner-info {
//       width: 90%;
//       margin-left: 5%;
//     }
//   }

//   .partner-item {
//     color: #353535;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/pages/index/home/partners.vue